import React from 'react';
import type { TabsTriggerProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';
import { Trigger } from '@components/main-components/tabs/Tab';

export function AudienceTabTrigger({
  children,
  icon,
  ...props
}: TabsTriggerProps & { icon: React.ReactNode }) {
  return (
    <Trigger
      className={twMerge(
        'flex h-auto w-full cursor-pointer items-center gap-1 whitespace-nowrap',
        'justify-center rounded-[6px] px-3 font-base !text-base-m font-normal',
        'capitalize disabled:cursor-not-allowed disabled:bg-neutral100 disabled:hover:bg-neutral100',
        'data-[state=active]:bg-neutral800 disabled:data-[state=active]:opacity-60 data-[state=active]:hover:bg-neutral800',
        'bg-neutral100 disabled:text-neutral400 hover:bg-neutral300 disabled:hover:text-base400',
        'text-neutral800 data-[state=active]:text-white hover:text-black data-[state=active]:hover:text-white',
      )}
      {...props}
    >
      {icon && (
        <div
          className={twMerge('flex h-[18px] w-[18px] items-center', props.disabled && 'opacity-60')}
        >
          {icon}
        </div>
      )}
      {children}
    </Trigger>
  );
}
